module.exports = __webpack_public_path__ + "static/3-f941293e17f9a2bff7d94e7725e7d636.jpeg";